import React, { useState } from 'react';
import { X, ZoomIn, ZoomOut } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { EcgTrace } from './EcgTrace';

export const EcgDetailDialog = ({ pattern, lead, onClose, annotated }) => {
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState(0);
  const duration = pattern.duration / zoom;
  const changeZoom = value => {
    setZoom(value);
    setOffset(Math.min(offset, pattern.duration - pattern.duration / value));
  };
  return (
    <Dialog open={Boolean(lead)} onOpenChange={open => { if (!open) onClose(); }}>
      <DialogContent data-testid="ekg-detail-dialog" className="ekg-dialog [&>button]:hidden">
        <div className="flex justify-between gap-3 items-start pr-1">
          <div className="min-w-0">
            <DialogTitle className="text-lg" data-testid="ekg-detail-title">{pattern.title} · {lead}</DialogTitle>
            <DialogDescription className="mt-1 text-xs">Schematisches Lehrbeispiel · keine Patientenaufzeichnung</DialogDescription>
          </div>
          <DialogClose asChild><Button size="icon" variant="ghost" aria-label="Detailansicht schließen" data-testid="ekg-detail-close"><X size={20} /></Button></DialogClose>
        </div>
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm font-medium" data-testid="ekg-detail-lead">Ableitung {lead}</p>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" disabled={zoom === 1} onClick={() => changeZoom(zoom / 2)} aria-label="Ausschnitt verkleinern" title="Ausschnitt verkleinern" data-testid="ekg-zoom-out"><ZoomOut size={18} /></Button>
            <span className="w-8 text-center text-sm" data-testid="ekg-zoom-level">{zoom}×</span>
            <Button variant="outline" size="icon" disabled={zoom === 4} onClick={() => changeZoom(zoom * 2)} aria-label="Ausschnitt vergrößern" title="Ausschnitt vergrößern" data-testid="ekg-zoom-in"><ZoomIn size={18} /></Button>
          </div>
        </div>
        <div className="border rounded-md overflow-hidden"><EcgTrace pattern={pattern} lead={lead} duration={duration} start={offset} annotated={annotated} testId="ekg-detail-trace" /></div>
        {zoom > 1 && <div>
          <label htmlFor="ekg-offset" className="flex justify-between text-xs mb-2 gap-2">Zeitfenster <span data-testid="ekg-window-time">{offset.toFixed(2)}–{(offset + duration).toFixed(2)} s</span></label>
          <input id="ekg-offset" type="range" min="0" max={pattern.duration - duration} step="0.01" value={offset} onChange={event => setOffset(Number(event.target.value))} className="w-full accent-teal-700" data-testid="ekg-window-slider" />
        </div>}
        <p className="text-xs text-muted-foreground" data-testid="ekg-detail-scale">Großes Rasterfeld: 0,2 s / 0,5 mV. Referenz: 25 mm/s, 10 mm/mV; Anzeige skaliert, nicht am Bildschirm abmessen.</p>
      </DialogContent>
    </Dialog>
  );
};